import React, { useEffect } from "react";

import "bootstrap/scss/bootstrap.scss";
import "../public/scss/default/euclid-circulara.scss";

// ========= Plugins CSS START =========
import "../node_modules/sal.js/dist/sal.css";
import "../public/css/plugins/fontawesome.min.css";
import "../public/css/plugins/feather.css";
import "../public/css/plugins/odometer.css";
import "../public/css/plugins/animation.css";
import "../public/css/plugins/euclid-circulara.css";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/effect-cards";
import "swiper/css/free-mode";
import "swiper/css/thumbs";
// ========= Plugins CSS END =========
import "react-toastify/dist/ReactToastify.css";

import "../public/scss/styles.scss";
import { Provider } from "react-redux";
import Store from "@/redux/store";
import Context from "@/context/Context";
import AuthProvider from "@/context/auth/AuthContext";
import { ToastContainer } from "react-toastify";

export default function App({ Component, pageProps }) {
  useEffect(() => {
    require("bootstrap/dist/js/bootstrap.bundle.min.js");
  }, []);

  return (
    <Provider store={Store}>
      <ToastContainer />
      <Context>
        <AuthProvider>
          <Component {...pageProps} />
        </AuthProvider>
      </Context>
    </Provider>
  );
}
